import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels/dist/chartjs-plugin-datalabels';
import { AlertaService } from 'src/app/util/alerta.service';
import { ConfirmDialogComponent } from 'src/app/util/confirm-dialog/confirm-dialog.component';
import { ConfirmDialog } from 'src/app/util/confirm-dialog/confirmDialog';
import { functionUtil } from 'src/app/util/functionConst';
import { ParametrosConst } from 'src/app/util/parametrosConst';
import { Pregunta } from '../../../model/pregunta';
import { Estadistica } from '../../model/estadistica';
import { DialogAumentarTiempoComponent } from './dialog-aumentar-tiempo/dialog-aumentar-tiempo.component';
import { EnviarEstadisticaComponent } from './enviar-estadistica/enviar-estadistica.component';
import { ResultadoService } from './resultado.service';

@Component({
  selector: 'sura-resultado',
  templateUrl: './resultado.component.html',
  styleUrls: ['./resultado.component.scss']
})
export class ResultadoComponent implements OnInit {
  linkActive = '';
  nroAsambleaValidacion: UntypedFormControl = null;

  constructor(private _resultadoService: ResultadoService,
    private alertaService: AlertaService,
    public dialog: MatDialog,
    private router: Router) {
    this.linkActive = this.router.url;
    Chart.plugins.unregister(ChartDataLabels);
    Chart.defaults.global.defaultFontFamily = "'fs_sura_sans', normal";
    this.nroAsambleaValidacion = new UntypedFormControl('', [Validators.required,
    Validators.maxLength(6),
    Validators.pattern('[0-9]+')]);
  }

  fnKeyDownNumeric = functionUtil.fnKeyDownNumeric;
  fnInputMaxLength = functionUtil.fnInputMaxLength;
  fnNumericMobile = functionUtil.fnNumericMobile;

  newEstadistica = new Estadistica();
  listPreguntas: Pregunta[] = [];
  myChart;
  _idPreguntaRefresh: number;
  _idAsambleaRefresh: number;
  isFullScreen = true;
  enabledTooltips = false;

  ngOnInit() {
    window['fnConfirmDialogResultado'] = this.openConfirmDialog;
    window['instanceResultadoComponent'] = this;
    this.dibujarEstadistica();
  }

  openFull() {
    this.isFullScreen = false;
    const elem = document.getElementById('form-resultado');
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    }
  }

  closeFull() {
    this.isFullScreen = true;
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }

  getErrorMessageNroAsamblea() {
    return this.nroAsambleaValidacion.hasError('required') ? 'Campo Obligatorio ' :
      this.nroAsambleaValidacion.hasError('maxlength') ? 'Max 6 caracteres' :
        this.nroAsambleaValidacion.hasError('pattern') ? 'Solo se acepta números' :
          '';
  }

  buscarPregunta() {
    this.limpiarDatos();
    this._resultadoService.listarPreguntas(this.newEstadistica.idAsamblea).then(preguntas => {
      if (preguntas instanceof Array) {
        this.listPreguntas = preguntas;
        this.seleccionarPreguntaDefecto();
      }
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  seleccionarPreguntaDefecto() {
    this.listPreguntas.forEach(pregunta => {
      if (pregunta.orden === 1) {
        this.newEstadistica.idPregunta = pregunta.id;
        this.buscarEstadistica();
      }
    });
  }

  iniciarContadorTiempoRestante() {
    this.clearIntervalContadorTiempoRestante();
    this.calcularTiempoRestante();
  }

  calcularTiempoRestante() {
    const minuto = Math.floor(this.newEstadistica.tiempoRestante / 60);
    const segundo = this.newEstadistica.tiempoRestante - minuto * 60;
    window['tiempoRestante'] = { minuto, segundo };
    if (this.newEstadistica.estado === 'I') {
      window['fnIntervalTiempoRestante'] = setInterval(this.descontarTiempoRestante, 1000);
    }
  }

  clearIntervalContadorTiempoRestante() {
    if (window['fnIntervalTiempoRestante'] != null) {
      clearInterval(window['fnIntervalTiempoRestante']);
    }
  }

  buscarEstadistica() {
    this._resultadoService.obtenerEstadistica(this.newEstadistica.idAsamblea, this.newEstadistica.idPregunta).then(estadis => {
      this._idAsambleaRefresh = this.newEstadistica.idAsamblea;
      this._idPreguntaRefresh = this.newEstadistica.idPregunta;
      this.newEstadistica.porcentajes = estadis['porcentajes'];
      this.newEstadistica.tiempoRestante = estadis['tiempoRestante'];
      this.newEstadistica.totalAsistentes = estadis['totalAsistentes'];
      this.newEstadistica.totalMiembros = estadis['totalMiembros'];
      this.newEstadistica.totalVotos = estadis['totalVotos'];
      this.newEstadistica.estado = estadis['estado'];
      this.newEstadistica.tipoQuorum = estadis['tipoQuorum'];
      let quorum = (estadis["totalQuorum"] * 100).toFixed(2);
      let cuotas = (estadis["totalCuotas"] * 100).toFixed(2);

      let totalCuotas = (estadis["totalCuotasAsamblea"] * 100).toFixed(2);

      this.newEstadistica.totalCuotas = Number(cuotas);
      this.newEstadistica.totalQuorum = Number(quorum);
      this.newEstadistica.totalCuotasAsamblea = Number(totalCuotas);
      this.dibujarEstadistica(estadis['tipoPregunta']);
      window.document.getElementById('intervalTiempoRestante').textContent = '00 : 00';
      this.iniciarContadorTiempoRestante();
      this.iniciarIntervalEstadistica();
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  getDataEstadistica() {
    const arrayData = [];
    const arrayLabel = [];
    let arrayBackgroundColor = [];
    if (this.newEstadistica.totalVotos === 0) {
      window['indResultadoVacia'] = true;
      arrayData.push('1');
      arrayLabel.push('Sin Voto');
      arrayBackgroundColor.push('rgb(126,	128	,131)');
      this.enabledTooltips = false;
    } else {
      window['indResultadoVacia'] = false;
      this.enabledTooltips = true;
      arrayBackgroundColor = [
        'rgb(30,	46,	110)', 'rgb(0,	174,	203)', 'rgb(227,	232,	41)', 'rgb(220,	221,	222)', 'rgb(183,	176, 156)', 'rgb(154, 185, 173)', 'rgb(205, 167, 136)', 'rgb(156, 162, 162)', 'rgb(163, 147, 130)'
      ];
      for (let index = 0; index < this.newEstadistica.porcentajes.length; index++) {
        arrayData.push(this.newEstadistica.porcentajes[index].porcentaje);
        if(this.newEstadistica.tipoQuorum != null && this.newEstadistica.tipoQuorum == "C"){
          arrayLabel.push(this.newEstadistica.porcentajes[index].voto + ' / Cuotas : ' + this.newEstadistica.porcentajes[index].cuotas);
        }else{
        arrayLabel.push(this.newEstadistica.porcentajes[index].voto + '(' +
          this.newEstadistica.porcentajes[index].cantidad + ' votos) / ' + this.newEstadistica.porcentajes[index].porcentaje + '%  Cuotas : ' + this.newEstadistica.porcentajes[index].cuotas );
        }
      }
    }

    return { arrayData, arrayLabel, arrayBackgroundColor };
  }

  dibujarEstadistica(tipoPregunta: number = ParametrosConst.PREGUNTA_SIMPLE) {
    const dataset = this.getDataSet(tipoPregunta);
    const config = {
      type: tipoPregunta === ParametrosConst.PREGUNTA_SIMPLE ? 'doughnut' : 'bar',
      data: {
        datasets: dataset,
        labels: tipoPregunta === ParametrosConst.PREGUNTA_SIMPLE ? this.getDataEstadistica()['arrayLabel'] : ['']
      },
      plugins: [ChartDataLabels],
      options: {
        legend: {
          display: true
        },
        scales: tipoPregunta === ParametrosConst.PREGUNTA_MULTIPLE ? {
          yAxes: [{
            ticks: {
              reverse: false,
              beginAtZero: true,
              suggestedMin: 0,
              suggestedMax: 100
            }
          }]
        } : {},
        responsive: true,
        tooltips: {
          enabled: true,
          callbacks: {
            label(tooltipItem, data) {
              if (data.labels.length === 1 && data.labels[0] === '') {
               return data.datasets[tooltipItem.datasetIndex].label;
              }
              return data.labels[tooltipItem.index];
            }
          }
        },
        plugins: {
          datalabels: {
            backgroundColor(context) {
              return context.dataset.backgroundColor;
            },
            borderColor: 'white', borderRadius: 25, borderWidth: 1, color: 'white',
            display(context) {
              /*var dataset = context.dataset;
              var count = dataset.data.length;
              var value = dataset.data[context.dataIndex];*/
              return true && !window['indResultadoVacia'];
            },
            formatter(value, context) {
              return value + '%';
            },
            font: { weight: 'bold' }
          }
        }
      }
    };
    if (this.myChart != null) {
      this.myChart.destroy();
    }
    const ctx = document.getElementById('chart-area');

    this.myChart = new Chart(ctx, config);
  }

  getDataSet(tipoPregunta: number) {
    let dataset = [];
    const data = this.getDataEstadistica()['arrayData'];
    const bg = this.getDataEstadistica()['arrayBackgroundColor'];
    const label = this.getDataEstadistica()['arrayLabel'];

    if (tipoPregunta === ParametrosConst.PREGUNTA_MULTIPLE ) {
      for (let i = 0; i < data.length; i++) {
        dataset.push({
          label: label[i].substring(0, label[i].indexOf('(')) + label[i].substring(label[i].indexOf(')') + 1, label[i].lenght),
          backgroundColor: bg[i],
          /*hoverBorderColor: "rgba(255,99,132,1)",*/
          data: [data[i]],
       });
      }
    } else {
      dataset = [{
        data: data,
        backgroundColor: bg,
        datalabels: {
          anchor: 'center'
        }
      }];
    }

    return dataset;
  }

  openDialogAumentarTiempo(): void {
    const dialogRef = this.dialog.open(DialogAumentarTiempoComponent, {
      width: '270px',
      data: { tiempoAdicional: '0' },
      disableClose: true,
      panelClass: 'full-screen-modal'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const pregunta = new Pregunta();
        pregunta.tiempoAdicional = result;
        pregunta.id = this.newEstadistica.idPregunta;
        pregunta.idAsamblea = this.newEstadistica.idAsamblea;
        this._resultadoService.aumentarTiempoAsignado(pregunta).then(resp => {
          this.alertaService.success(resp);
          this.newEstadistica.tiempoRestante = resp['tiempo'];
          this.iniciarContadorTiempoRestante();
        }).catch(err => {
          this.alertaService.error(err);
        });
      }
    });
  }

  openConfirmDialog(): void {
    const confirmDialog: ConfirmDialog = new ConfirmDialog();
    confirmDialog.message = 'Se terminó el tiempo asignado, ¿Desea terminar la votación?';
    confirmDialog.labelOk = 'Finalizar';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '270px',
      data: confirmDialog,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined' && result.flagRespuesta) {
        this.finalizarVotacion();
      } else {
        this.openDialogAumentarTiempo();
      }
    });
  }

  iniciarVotacion() {
    this._resultadoService.iniciarVotacion(this.newEstadistica.idAsamblea, this.newEstadistica.idPregunta).then(resp => {
      this.alertaService.success(resp);
      this.buscarEstadistica();
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  getOrdenPregunta() {
    let orden;
    for (let index = 0; index < this.listPreguntas.length; index++) {
      if (this.newEstadistica.idPregunta === this.listPreguntas[index].id) {
        orden = this.listPreguntas[index].orden;
        break;
      }
    }
    return orden;
  }

  finalizarVotacion() {
    this._resultadoService.finalizarVotacion(
      this.newEstadistica.idAsamblea, this.newEstadistica.idPregunta, this.getOrdenPregunta()
    ).then(resp => {
      this.alertaService.success(resp);
      this.buscarEstadistica();
      this.clearIntervalEstadistica();
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  descontarTiempoRestante() {
    let minuto = window['tiempoRestante'].minuto;
    if (window['tiempoRestante'].segundo > 0) {
      window['tiempoRestante'].segundo--;
    }
    let segundo = window['tiempoRestante'].segundo;
    const text = window.document.getElementById('intervalTiempoRestante');
    let textMinuto = minuto + '';
    let textSegundo = segundo + '';
    if (minuto < 10) {
      textMinuto = '0' + minuto;
    }
    if (segundo < 10) {
      textSegundo = '0' + segundo;
    }
    text.textContent = textMinuto + ' : ' + textSegundo;

    if (segundo === 0 && minuto > 0) {
      minuto--;
      segundo = 60;
      window['tiempoRestante'] = { minuto, segundo };
    }
    if ((minuto === 0 && segundo === 0)) {
      if (window['fnIntervalTiempoRestante'] != null) {
        clearInterval(window['fnIntervalTiempoRestante']);
      }
      if (window['instanceResultadoComponent'] instanceof Object) {
        window['instanceResultadoComponent'].openConfirmDialog();
      }
    }
  }

  limpiarDatos() {
    this.listPreguntas = [];
    this.newEstadistica.id = null;
    this.newEstadistica.totalMiembros = 0;
    this.newEstadistica.totalAsistentes = 0;
    this.newEstadistica.totalVotos = 0;
    this.newEstadistica.totalQuorum = 0;
    this.newEstadistica.totalCuotas = 0;
    // const f = this.newEstadistica.porcentajes.slice(0, this.newEstadistica.porcentajes.length);
    this.newEstadistica.tiempoRestante = 0;
    this.newEstadistica.estado = 'P';
    if (this.newEstadistica.idPregunta != null) {
      this.dibujarEstadistica();
    }
    this.newEstadistica.idPregunta = null;
    this.clearIntervalEstadistica();
  }

  iniciarIntervalEstadistica() {
    if (this.newEstadistica.estado === 'I') {
      this.clearIntervalEstadistica();
      window['fnIntervalEstadistico'] = setInterval(this.fnRefrescarEstadistica, 5000);
    } else {
      this.clearIntervalEstadistica();
    }
  }

  clearIntervalEstadistica() {
    clearInterval(window['fnIntervalEstadistico']);
  }

  fnRefrescarEstadistica() {
    window['instanceResultadoComponent'].refrescarEstadistica();
  }
  refrescarEstadistica() {
    this._resultadoService.obtenerEstadistica(this._idAsambleaRefresh, this._idPreguntaRefresh).then(estadis => {
      this.newEstadistica.porcentajes = estadis['porcentajes'];
      this.newEstadistica.tiempoRestante = estadis['tiempoRestante'];
      this.newEstadistica.totalAsistentes = estadis['totalAsistentes'];
      this.newEstadistica.totalMiembros = estadis['totalMiembros'];
      this.newEstadistica.totalVotos = estadis['totalVotos'];
      this.newEstadistica.estado = estadis['estado'];
      let quorum = (estadis["totalQuorum"] * 100).toFixed(2);
      let cuotas = (estadis["totalCuotas"] * 100).toFixed(2);
      this.newEstadistica.totalCuotas = Number(cuotas);
      this.newEstadistica.totalQuorum = Number(quorum);
      this.dibujarEstadistica(estadis['tipoPregunta']);
      if (this.newEstadistica.estado === 'F') {
        this.clearIntervalEstadistica();
      }
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  obtenerRutaQR() {
    return ParametrosConst.QR_CONTENT;
  }

  openDialogEnviarResultado(): void {
    const dialogRef = this.dialog.open(EnviarEstadisticaComponent, {
      width: '800px',
      data: { idAsamblea: this.newEstadistica.idAsamblea },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.alertaService.success('se envió');
      }
    });
  }
}
